import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Conflict of Interest")
], -1)
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = { class: "d-flex flex-stack" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Do any of the Investigators or personnel listed on this research have a potential conflict of interest associated with this study?")
], -1)
const _hoisted_8 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_9 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row mb-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please select the investigator")
], -1)
const _hoisted_13 = { class: "col-lg-12 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  disabled: ""
}, "Select an option", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "row mb-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "form-label required" }, "Please select the category of conflict of interest ")
], -1)
const _hoisted_18 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "A researcher or family member participating in research on a technology owned by a business in which the faculty member holds a financial interest")
  ])
], -1)
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_21 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "A researcher participating in research on a technology developed by that researcher")
  ])
], -1)
const _hoisted_23 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_24 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "A researcher or family member assuming an executive position in a business engaged in commercial or research activities")
  ])
], -1)
const _hoisted_26 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_27 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center me-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "A researcher or family member serving on the Board of Directors of a business from which that member receives University-supervised Sponsored Research Support")
  ])
], -1)
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_30 = { class: "fv-row mb-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please describe the conflict of interest"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "hasConflict",
              value: "1",
              modelValue: _ctx.step5.hasConflict,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step5.hasConflict) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.step5.hasConflict == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      (_ctx.currentCoInvestigators.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  id: "dynamic-select",
                  name: "investigatorId",
                  "data-control": "select2",
                  "data-hide-search": "true",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step5.investigatorId) = $event))
                }, [
                  _hoisted_14,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCoInvestigators, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: 
                  option.title + ' ' + option.firstname + ' ' + option.lastname
                
                    }, _toDisplayString(option.title) + " " + _toDisplayString(option.firstname) + " " + _toDisplayString(option.lastname), 9, _hoisted_15))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.step5.investigatorId]
                ]),
                _createVNode(_component_Field, {
                  type: "hidden",
                  name: "investigatorId",
                  class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                  placeholder: "How it will be record?",
                  modelValue: _ctx.step5.investigatorId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step5.investigatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "investigatorId",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ], 512), [
              [_vShow, _ctx.step5.hasConflict === '1']
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("label", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              modelValue: _ctx.step5.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step5.description) = $event)),
              name: "description",
              value: "A researcher or family member participating in research on a technology owned by a business in which the faculty member holds a financial interest"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("label", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              modelValue: _ctx.step5.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step5.description) = $event)),
              name: "description",
              value: "A researcher participating in research on a technology developed by that researcher"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("label", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              modelValue: _ctx.step5.description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step5.description) = $event)),
              name: "description",
              value: "A researcher or family member assuming an executive position in a business engaged in commercial or research activities"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("label", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              modelValue: _ctx.step5.description,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step5.description) = $event)),
              name: "description",
              value: "A researcher or family member serving on the Board of Directors of a business from which that member receives University-supervised Sponsored Research Support"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "description",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ], 512), [
        [_vShow, _ctx.step5.hasConflict === '1']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createVNode(_component_editor, {
          for: "coiDescription",
          initialValue: "step5.coiDescription",
          modelValue: _ctx.step5.coiDescription,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step5.coiDescription) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "coiDescription",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step5.coiDescription,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step5.coiDescription) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "coiDescription",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ], 512), [
        [_vShow, _ctx.step5.hasConflict === '1']
      ])
    ])
  ]))
}